import { render, staticRenderFns } from "./PanelLinkGoTo.vue?vue&type=template&id=09998e0b"
import script from "./PanelLinkGoTo.vue?vue&type=script&lang=js"
export * from "./PanelLinkGoTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports